import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import IMetadata from '../../../app/_interfaces/IMetadata';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  public allMetadata$: Subject<IMetadata[]>;

  constructor(private http: HttpClient) {
    this.allMetadata$ = new Subject<IMetadata[]>();
  }

  getAll(customers_id: number) {
    return this.get(customers_id).subscribe((metadata: IMetadata[]) => {
      this.allMetadata$.next(metadata);
    });
  }

  get(customers_id: number) {
    return this.http.get<IMetadata[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata`,
      {}
    );
  }

  create(customers_id: number, metadata: IMetadata) {
    return this.http.post<IMetadata>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata`,
      metadata
    );
  }

  delete(customers_id: number, metadata_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata/${metadata_id}`
    );
  }
}
